import React, { useState, useRef, useEffect } from 'react'
import './style.css'
import ReactToPrint from 'react-to-print'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import wisc4Icon1 from '../../../../../assets/SarbargWisc4-1.png'
import wisc4Icon2 from '../../../../../assets/SarbargWisc4-2.png'
import sensory2Icon from '../../../../../assets/SarbargSensoryProfile2Child.png'
import sensory2Chart from '../../../../../assets/ChartSensoryProfile2.png'
const faScoboQuestions = require('../../../../../utils/scoboTestQuestionsFa.js')
const faGars2Questions = require('../../../../../utils/gars2TestQuestionsFa.js')
const faGars3Questions = require('../../../../../utils/gars3TestQuestionsFa.js')
const faSensory2Questions = require('../../../../../utils/sensory2TestQuestionsFa.js')
const faNumbers = require('../../../../../utils/numbersFa.js')

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

function ResultModalSensory2({ evaluation, closeModal, testStats, clinicName }) {

    const [testName, setTestName] = useState(evaluation.Session)
    const [testIndex, setTestIndex] = useState(evaluation.Index)
    const [testAnswer, setTestAnswer] = useState(evaluation.Answers)
    const [testQuestion, setTestQuestion] = useState(evaluation.Questions)
    const [testSubscales, setTestSubscales] = useState(evaluation.Subscales)
    const [testPercentiles, setTestPercentiles] = useState(evaluation.Percentiles)
    const [testStartDate, setTestStartDate] = useState(evaluation.StartDate)
    const [testStartDateDay, setTestStartDateDay] = useState(new Date(evaluation.StartDate).toLocaleDateString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).slice(8,10))
    const [testStartDateMonth, setTestStartDateMonth] = useState(new Date(evaluation.StartDate).toLocaleDateString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).slice(5,7))
    const [testStartDateYear, setTestStartDateYear] = useState(new Date(evaluation.StartDate).toLocaleDateString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).slice(0,4))
    const [examinerName, setExaminerName] = useState(evaluation.Examiner)
    const [resultAds, setResultAds] = useState(evaluation.Result)
    const [score, setScore] = useState(evaluation.Score)
    const [name, setName] = useState(testStats.firstname)
    const [lName, setLName] = useState(testStats.lastname)
    const [birthResult, setBirthResult] = useState(testStats.birthdate)
    const [birthDay, setBirthDay] = useState(new Date(testStats.birthdate).toLocaleDateString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).slice(8,10))
    const [birthMonth, setBirthMonth] = useState(new Date(testStats.birthdate).toLocaleDateString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).slice(5,7))
    const [birthYear, setBirthYear] = useState(new Date(testStats.birthdate).toLocaleDateString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).slice(0,4))
    const [clinic, setClinic] = useState(clinicName)
    const [adsResults, setAdsResults] = useState([])
    const [ageDay, setAgeDay] = useState(0)
    const [ageMonth, setAgeMonth] = useState(0)
    const [ageYear, setAgeYear] = useState(0)
    const farsiNumbers = faNumbers

    const userPercentileText = 
    [
        "حس‌جویی",
        "اجتناب حسی",
        "حساسیت حسی",
        "ثبت حسی",
        "شنیداری",
        "دیداری",
        "لامسه",
        "حرکتی",
        "موقعیت بدن",
        "دهانی",
        "سلوک",
        "هیجان اجتماعی",
        "توجه و تمرکز",
    ]

    const userSubscaleText = 
    [
        "درک مطلب کلامی",
        "استدلال ادراکی",
        "حافظه فعال",
        "سرعت پردازش",
        "مقیاس کل",
    ]

    const componentRef = useRef(null);

    const datesCalculator = () => {
        var birthDate = new Date(birthResult)
        var examDate = new Date(testStartDate)
        var currentDate = new Date()
        var ageDayTemp = new Date(examDate - birthDate)
        var ageMonthTemp = new Date(examDate - birthDate)
        var ageYearTemp = new Date(examDate - birthDate)
        
        setAgeDay(ageDayTemp.getDate())
        setAgeMonth(ageMonthTemp.getMonth())
        setAgeYear(ageYearTemp.getFullYear() - 1970)

        if (birthDay[0] == '۰') setBirthDay(birthDay[1])
        if (birthMonth[0] == '۰') setBirthMonth(birthMonth[1])
        if (testStartDateDay[0] == '۰') setTestStartDateDay(testStartDateDay[1])
        if (testStartDateMonth[0] == '۰') setTestStartDateMonth(testStartDateMonth[1])
    }

    useEffect (() => {
        console.log("received id in this page is:", evaluation);
        datesCalculator()
    }, [])

    var userQuestion = []
    if (testName == 'SCOBO') userQuestion = faScoboQuestions
    if (testName == 'GARS2') userQuestion = faGars2Questions
    if (testName == 'GARS3') userQuestion = faGars3Questions
    if (testName == 'SENSORY2') {
        if (ageYear >= 3)
            userQuestion = faSensory2Questions[2]
    }

    return (
        <div className='result-modal-background'>
            <div className='result-modal-container'>
                <div className='results-print' ref={componentRef}>
                    <div style={{marginTop: '0', marginBottom: '0'}} className='result-spec-table mode-text-9'>
                        <div className='result-spec-right-wrapper font-12'>
                            {/* <div style={{lineHeight: '1rem'}}>
                                <p>نام آزمودنی: {name} {lName}</p>
                                <p> نام آزمونگر: {examinerName}</p>
                            </div> */}
                            <div>
                                <h>محاسبه سن</h>
                                <table className='w-100 mb-3' cellSpacing={0} style={{border: 'none'}}>
                                    <thead>
                                        <tr>
                                            <td style={{visibility: 'hidden'}}></td>
                                            <td>روز</td>
                                            <td>ماه</td>
                                            <td>سال</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>تاریخ اجرا</td>
                                            <td>{testStartDateDay}</td>
                                            <td>{testStartDateMonth}</td>
                                            <td>{testStartDateYear}</td>
                                        </tr>
                                        <tr>
                                            <td>تاریخ تولد</td>
                                            <td>{birthDay}</td>
                                            <td>{birthMonth}</td>
                                            <td>{birthYear}</td>
                                        </tr>
                                        <tr>
                                            <td>سن</td>
                                            <td>{farsiNumbers[ageDay]}</td>
                                            <td>{farsiNumbers[ageMonth]}</td>
                                            <td>{farsiNumbers[ageYear]}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div>
                                <img src={sensory2Chart} style={{width: '100%'}}></img>
                            </div>
                        </div>
                        <div className='result-spec-left-wrapper font-12'>
                            <div>
                                <img src={sensory2Icon} style={{width: '100%'}}></img>
                            </div>
                            <div style={{lineHeight: '1rem'}}>
                                <p>نام آزمودنی: {name} {lName}</p>
                                <p> نام آزمونگر: {examinerName}</p>
                            </div>
                        </div>
                    </div>
                    <div className='result-spec-table mode-text-9' style={{marginTop: 0}}>
                        <table className='w-100 d-ltr font-10' cellSpacing={0} style={{border: 'none'}}>
                            <thead>
                                <tr>
                                    <td style={{borderBottom: 'none', borderRight: 'none', background: '#84aa46'}}></td>
                                    <td style={{borderLeft: 'none', background: '#84aa46'}}></td>
                                    <td style={{background: '#84aa46', color: '#fff'}} colSpan={2}><p>{"کمتر از دیگران"}</p></td>
                                    <td style={{background: '#84aa46'}}></td>
                                    <td style={{background: '#84aa46', color: '#fff'}} colSpan={2}><p>{"بیشتر از دیگران"}</p></td>
                                </tr>
                                <tr>
                                    <td style={{borderTop: 'none', borderBottom: 'none', background: '#84aa46'}}></td>
                                    <td style={{borderBottom: 'none', background: '#e7f2ae'}}></td>
                                    <td style={{width: '10%'}}><p>{"بسیار"}</p><p>{"کمتر از"}</p><p>{"دیگران"}</p></td>
                                    <td style={{width: '10%'}}><p>{"کمتر از"}</p><p>{"دیگران"}</p></td>
                                    <td style={{width: '10%'}}>{"مشابه اکثر افراد"}</td>
                                    <td style={{width: '10%'}}><p>{"بیشتر از"}</p><p>{"دیگران"}</p></td>
                                    <td style={{width: '10%'}}><p>{"بسیار"}</p><p>{"بیشتر از"}</p><p>{"دیگران"}</p></td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={{height: '30px'}}>
                                    <td rowSpan={4} style={{width: '5%', borderTop: 'none', background: '#84aa46', color: '#fff'}}>
                                        <div className='rotate-90'>{"ربع‌ها"}</div>
                                    </td>
                                    <td style={{borderTop: 'none', background: '#e7f2ae'}}>{"حس‌جویی"}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[0] == 0 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[0] == 1 && 'x'}</td>
                                    <td style={{background: '#c4d385'}}>{testPercentiles[0] == 2 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[0] == 3 && 'x'}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[0] == 4 && 'x'}</td>
                                </tr>
                                <tr style={{height: '30px'}}>
                                    <td style={{background: '#e7f2ae'}}>{"اجتناب حسی"}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[1] == 0 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[1] == 1 && 'x'}</td>
                                    <td style={{background: '#c4d385'}}>{testPercentiles[1] == 2 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[1] == 3 && 'x'}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[1] == 4 && 'x'}</td>
                                </tr>
                                <tr style={{height: '30px'}}>
                                    <td style={{background: '#e7f2ae'}}>{"حساسیت حسی"}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[2] == 0 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[2] == 1 && 'x'}</td>
                                    <td style={{background: '#c4d385'}}>{testPercentiles[2] == 2 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[2] == 3 && 'x'}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[2] == 4 && 'x'}</td>
                                </tr>
                                <tr style={{height: '30px'}}>
                                    <td style={{background: '#e7f2ae'}}>{"ثبت حسی"}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[3] == 0 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[3] == 1 && 'x'}</td>
                                    <td style={{background: '#c4d385'}}>{testPercentiles[3] == 2 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[3] == 3 && 'x'}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[3] == 4 && 'x'}</td>
                                </tr>
                                <tr style={{height: '30px'}}>
                                    <td rowSpan={6} style={{background: '#84aa46', color: '#fff'}}>
                                        <div className='rotate-90'>{"بخش‌های حسی"}</div>
                                    </td>
                                    <td style={{background: '#e7f2ae'}}>{"شنیداری"}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[4] == 0 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[4] == 1 && 'x'}</td>
                                    <td style={{background: '#c4d385'}}>{testPercentiles[4] == 2 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[4] == 3 && 'x'}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[4] == 4 && 'x'}</td>
                                </tr>
                                <tr style={{height: '30px'}}>
                                    <td style={{background: '#e7f2ae'}}>{"دیداری"}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[5] == 0 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[5] == 1 && 'x'}</td>
                                    <td style={{background: '#c4d385'}}>{testPercentiles[5] == 2 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[5] == 3 && 'x'}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[5] == 4 && 'x'}</td>
                                </tr>
                                <tr style={{height: '30px'}}>
                                    <td style={{background: '#e7f2ae'}}>{"لامسه"}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[6] == 0 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[6] == 1 && 'x'}</td>
                                    <td style={{background: '#c4d385'}}>{testPercentiles[6] == 2 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[6] == 3 && 'x'}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[6] == 4 && 'x'}</td>
                                </tr>
                                <tr style={{height: '30px'}}>
                                    <td style={{background: '#e7f2ae'}}>{"حرکتی"}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[7] == 0 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[7] == 1 && 'x'}</td>
                                    <td style={{background: '#c4d385'}}>{testPercentiles[7] == 2 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[7] == 3 && 'x'}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[7] == 4 && 'x'}</td>
                                </tr>
                                <tr style={{height: '30px'}}>
                                    <td style={{background: '#e7f2ae'}}>{"موقعیت بدن"}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[8] == 0 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[8] == 1 && 'x'}</td>
                                    <td style={{background: '#c4d385'}}>{testPercentiles[8] == 2 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[8] == 3 && 'x'}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[8] == 4 && 'x'}</td>
                                </tr>
                                <tr style={{height: '30px'}}>
                                    <td style={{background: '#e7f2ae'}}>{"دهانی"}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[9] == 0 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[9] == 1 && 'x'}</td>
                                    <td style={{background: '#c4d385'}}>{testPercentiles[9] == 2 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[9] == 3 && 'x'}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[9] == 4 && 'x'}</td>
                                </tr>
                                <tr style={{height: '30px'}}>
                                    <td rowSpan={3} style={{background: '#84aa46', color: '#fff'}}>
                                        <div className='rotate-90'>{"بخش‌های رفتاری"}</div>
                                    </td>
                                    <td style={{background: '#e7f2ae'}}>{"سلوک"}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[10] == 0 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[10] == 1 && 'x'}</td>
                                    <td style={{background: '#c4d385'}}>{testPercentiles[10] == 2 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[10] == 3 && 'x'}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[10] == 4 && 'x'}</td>
                                </tr>
                                <tr style={{height: '30px'}}>
                                    <td style={{background: '#e7f2ae'}}>{"هیجان اجتماعی"}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[11] == 0 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[11] == 1 && 'x'}</td>
                                    <td style={{background: '#c4d385'}}>{testPercentiles[11] == 2 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[11] == 3 && 'x'}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[11] == 4 && 'x'}</td>
                                </tr>
                                <tr style={{height: '30px'}}>
                                    <td style={{background: '#e7f2ae'}}>{"توجه و تمرکز"}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[12] == 0 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[12] == 1 && 'x'}</td>
                                    <td style={{background: '#c4d385'}}>{testPercentiles[12] == 2 && 'x'}</td>
                                    <td style={{background: '#e7f2ae'}}>{testPercentiles[12] == 3 && 'x'}</td>
                                    <td style={{background: '#f3facf'}}>{testPercentiles[12] == 4 && 'x'}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {/* <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '300px'}}>
                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart width={300} height={300}>
                                <Pie
                                    data={data}
                                    nameKey="label"
                                    dataKey="percentile"
                                    cx="50%"
                                    cy="50%"
                                    outerRadius={100}
                                    fill="#8884d8"
                                    label={renderCustomizedLabel}
                                >
                                    {data.map((color, i) => (
                                        <Cell key={`cell-${i}`} fill={COLORS[i % COLORS.length]} />
                                    ))}
                                </Pie>
                            </PieChart>
                        </ResponsiveContainer>
                    </div> */}

                    {/* <div style={{marginTop: '5px'}} className='result-table'>
                    {testPercentiles.map((subCount, i) => (
                        <div className='table-result-items' key={i}>
                            <p className='result-item-title' >{userPercentileText[i]}</p>
                            <p className='result-item-stats mode-text-13 w-35'>{farsiNumbers[testPercentiles[i]]}</p>
                            <p className='result-item-stats mode-text-13 w-35'>{farsiNumbers[1]}</p>
                        </div>
                    ))}
                    </div> */}

                    {/* <div style={{marginTop: '5px'}} className='result-table'>
                    {testSubscales.map((subCount, i) => (
                        <div className='table-result-items' key={i}>
                            <p className='result-item-title' >{userSubscaleText[i]}</p>
                            <p className='result-item-stats mode-text-13 w-35'>{farsiNumbers[testSubscales[i]]}</p>
                            <p className='result-item-stats mode-text-13 w-35'>{farsiNumbers[1]}</p>
                        </div>
                    ))}
                    </div> */}
                    
                    <div className='result-table'>
                        <div style={{marginTop: '10px', marginBottom: '10px'}} className='result-header mode-text-13'>
                            <div className='result-modal-title'> سوالات: </div>
                        </div>
                        {testQuestion.map((queCount, i) => (
                        <div className='table-result-items' >
                            <p className='result-item-stats'>{queCount}</p>
                            <p className='result-item-title font-12'>{userQuestion[i]}</p>
                            <p className='result-item-stats'>{testAnswer[i]}</p>
                        </div>
                        ))}
                    </div>
                </div>
                <div className='result-spec-table'>
                    <ReactToPrint 
                    trigger={() => <button style={{color: '#8D1D57'}}>چاپ نتایج</button>}
                    content={() => componentRef.current}
                    documentTitle= 'نتایج تست نمایه حسی ۲'
                    />
                    <button onClick={() => closeModal(false)}>
                        متوجه شدم
                    </button>
                </div>

            </div>
            
        </div>
    )
}

export default ResultModalSensory2